import { render, staticRenderFns } from "./CommonSampleStatusRenderer.vue?vue&type=template&id=0aec399b&"
import script from "./CommonSampleStatusRenderer.vue?vue&type=script&lang=js&"
export * from "./CommonSampleStatusRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports